import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbAccordionModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { HttpErrorModalComponent } from './http-error-modal/http-error-modal.component';
import { AccordionModule } from 'primeng/accordion';

@NgModule({
  declarations: [ErrorModalComponent, HttpErrorModalComponent],
  imports: [CommonModule, NgbModalModule, NgbAccordionModule, AccordionModule],
})
export class GlobalErrorHandlerModule {}
